import { render } from "./AlertView.vue?vue&type=template&id=07e0366d"
import script from "./AlertView.vue?vue&type=script&lang=js"
export * from "./AlertView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__